import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import rawData from '../../../data/charts'

import { convertToNumber, interpolate } from '../../../lib/helpers'
import ChartsDisplay from './ChartsDisplay'

const ChartsContainer = ({ activeYear, activeChart, lang }) => {
  const [data, setData] = useState([])

  useEffect(() => {
    PrepData()
  }, [])

  function PrepData() {
    const data = rawData
      .map(function transformData({
        year,
        population,
        overAbstraction,
        waterPerCapita
      }) {
        return {
          year: year,
          population: convertToNumber(population),
          overAbstraction: convertToNumber(overAbstraction),
          waterPerCapita: convertToNumber(waterPerCapita)
        }
      })
      .map(function interpolateData(obj, index, transformedData) {
        return obj.population > 0
          ? { ...obj }
          : {
              ...obj,
              population: interpolate(obj.year, index, transformedData)
            }
      })
    setData([...data])
  }

  function getVisibleData() {
    return data.filter(d => d.year <= activeYear + 9)
  }

  function getPrevAndCurrentNumbers() {
    const activeYearIndex = data.findIndex(({ year }) => year === activeYear)
    if (activeYearIndex === -1) {
      return {
        waterPerCapita: {
          current: 0,
          next: 0
        },
        abstraction: {
          current: 0,
          next: 0
        },
        population: {
          current: 0,
          next: 0
        }
      }
    }

    const next = data[activeYearIndex + 9]
    const current = data[activeYearIndex]

    return {
      waterPerCapita: {
        current: current.waterPerCapita,
        next: next.waterPerCapita
      },
      abstraction: {
        current: current.overAbstraction,
        next: next.overAbstraction
      },
      population: {
        current: current.population,
        next: next.population
      }
    }
  }

  const visibleData = getVisibleData()

  const {
    population: populationCount,
    abstraction: abstractionCount,
    waterPerCapita
  } = getPrevAndCurrentNumbers()

  return (
    <ChartsDisplay
      lang={lang}
      activeYear={activeYear}
      activeChart={activeChart}
      data={visibleData}
      populationCount={populationCount}
      abstractionCount={abstractionCount}
      waterPerCapita={waterPerCapita}
    />
  )
}

ChartsContainer.propTypes = {
  activeYear: PropTypes.number,
  activeChart: PropTypes.string,
  lang: PropTypes.string
}

export default ChartsContainer
